import { Link } from "react-router-dom";
import { MapPin, BadgeCheck } from "lucide-react";
import StarRating from "@/components/StarRating";

export default function ProfileCard({ p, index = 0 }) {
  return (
    <Link
      to={`/profile/${p.id}`}
      data-testid={`profile-card-${p.id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 70, 600)}ms` }}
    >
      <div className="img-zoom aspect-[4/5] bg-sand-100 mb-5 relative">
        {p.cover_image ? (
          <img src={p.cover_image} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-sand-200">
            <span className="font-serif text-5xl text-sand-300">{p.name?.[0] || "T"}</span>
          </div>
        )}
        <span className="absolute top-4 left-4 bg-forest-500 text-sand-50 px-3 py-1 font-mono text-[10px] tracking-[0.2em] uppercase">
          {p.type}
        </span>
        {p.verified && (
          <span className="absolute top-4 right-4 bg-brand-500 text-sand-50 px-2 py-1 font-mono text-[9px] flex items-center gap-1">
            <BadgeCheck size={11} /> Verified
          </span>
        )}
      </div>
      <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-forest-500 mb-2">
        Community Profile
      </div>
      <h3 className="font-serif text-2xl md:text-3xl font-bold text-sand-900 leading-tight group-hover:text-brand-500 transition-colors">
        {p.name}
      </h3>
      <div className="mt-2 flex items-center gap-1.5 text-sand-700 text-sm">
        <MapPin size={13} />
        <span>{p.neighborhood ? `${p.neighborhood} · ` : ""}{p.city}</span>
      </div>
      {p.review_count > 0 && (
        <div className="mt-2 flex items-center gap-2" data-testid={`card-community-rating-${p.id}`}>
          <StarRating value={p.community_rating} size={14} />
          <span className="font-mono text-[11px] text-sand-700">
            {p.community_rating.toFixed(1)} · {p.review_count} {p.review_count === 1 ? "review" : "reviews"}
          </span>
        </div>
      )}
      {p.bio && (
        <p className="mt-3 text-sand-700 text-sm font-light leading-relaxed line-clamp-2">{p.bio}</p>
      )}
    </Link>
  );
}
